export default "__VITE_ASSET__DFoO3mvw__"